import React from "react";

export default function ButtonCommonComponent({
  extraClassName,
  onClick,
  text,
  isDisabled,
}) {
  return (
    <>
      <button
        className={`login-btn ${extraClassName}`}
        onClick={onClick}
        disabled={isDisabled}
      >
        {text}
      </button>
    </>
  );
}

ButtonCommonComponent.defaultProps = {
  extraClassName: "",
  isDisabled: false,
};
